import { accessRouteChain } from './access-route-chain.js';
import { ROUTE_ACCESS } from './route-access.js';
// shipping:view opens the unscoped ships root, so no screen's View pulls it in (20261009140000_so_detail_permissions).
const NEVER_NEEDED = new Set(['shipping:view']);
function moduleOf(permission) {
    return permission.split(':')[0] ?? '';
}
function buildScreenNeeds() {
    const needs = new Map();
    for (const route of Object.keys(ROUTE_ACCESS)) {
        const owner = accessRouteChain(route).find((entry) => entry.required?.length)?.required?.[0];
        if (!owner)
            continue;
        const entry = ROUTE_ACCESS[route];
        const ownModule = moduleOf(owner);
        const reads = [...(entry.required ?? []), ...(entry.lookups ?? [])].filter((permission) => permission.endsWith(':view') &&
            !NEVER_NEEDED.has(permission) &&
            moduleOf(permission) !== ownModule &&
            permission !== entry.required?.[0]);
        if (reads.length === 0)
            continue;
        const moduleNeeds = needs.get(ownModule) ?? new Set();
        for (const permission of reads)
            moduleNeeds.add(permission);
        needs.set(ownModule, moduleNeeds);
    }
    return new Map([...needs].map(([module, set]) => [module, [...set].sort()]));
}
/** For each screen module, the other screens' View keys its pages read; built from `ROUTE_ACCESS`, so the denied page and the role editor agree. */
export const SCREEN_NEEDS = buildScreenNeeds();
//# sourceMappingURL=screen-needs.js.map